import { SeoImage } from './seo-image.type';

export class SeoData {
    title?: string;
    description?: string;
    type?: string;
    keywords?: string;
    image?: SeoImage;
}
